module.exports = __webpack_public_path__ + "img/UserNew.06b09f87.svg";